import React from 'react';

/**
 * Placeholder card shapes shown while a product grid is loading, instead of a
 * full-page spinner - the grid's actual layout appears instantly and content fills in,
 * which reads as faster even though the real fetch takes the same time.
 */
const SkeletonCard = () => (
  <div className="bg-white rounded-lg border border-gray-200 overflow-hidden animate-pulse">
    <div className="aspect-square bg-gray-200" />
    <div className="p-2.5 space-y-2">
      <div className="h-3 bg-gray-200 rounded w-full" />
      <div className="h-3 bg-gray-200 rounded w-2/3" />
      <div className="h-4 bg-gray-200 rounded w-1/2 mt-1" />
    </div>
  </div>
);

export default function ProductGridSkeleton({ count = 8, className = 'grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2 sm:gap-3' }) {
  return (
    <div className={className} aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}
